export let setElfImportPromise;
const waitPromise = new Promise((resolve) => {
  setElfImportPromise = resolve;
});

export function importElfGameJS() {
  return waitPromise;
}
